import type { ManifestMap } from '@xing-com/crate-core-assets';

export async function loadManifest(manifestUrl: string): Promise<ManifestMap> {
  return await fetch(manifestUrl).then((result) => {
    return result.json();
  });
}
